import { createAuth0Client, type Auth0Client, type Auth0ClientOptions } from '@auth0/auth0-spa-js';

const env = (key: keyof ImportMetaEnv) => import.meta.env[key];

export const isTestEnv = env('VITE_TEST_ENV') === 'true';

export const buildAuth0Options = (): Auth0ClientOptions => {
  return {
    domain: env('VITE_AUTH_DOMAIN') || 'turn-dev.us.auth0.com',
    clientId: env('VITE_AUTH_ID')!, // required by env typing

    // Makes SDK cache persistent.
    // If we don't want the SDK to use localStorage internally, remove this.
    cacheLocation: 'localstorage',

    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: env('VITE_AUTH0_AUDIENCE'),
      scope: 'openid profile email',
      //! IMPORTANT: do NOT set response_type; SPA SDK uses code+PKCE.
    },
  };
};

let clientPromise: Promise<Auth0Client> | null = null;

export const getAuth0Client = (): Promise<Auth0Client> => {
  if (!clientPromise) {
    clientPromise = createAuth0Client(buildAuth0Options());
  }
  return clientPromise;
};
